<!--分析师-->
<template>
  <div class="content_width_box">
      <div class="content_title">
        <div class="title_left_h2">{{ $t('investor.analyst.title') }}</div>
      </div>
      <div class="content_list_layout analyst_layout">
        <div class="analyst_title">
          <div>{{ $t('investor.analyst.institution') }}</div>
          <div>{{ $t('investor.analyst.name') }}</div>
        </div>
        <div class="analyst_list">
          <div>CCBI</div>
          <div>Ronnie Ho</div>
        </div>
        <div class="analyst_list">
          <div>China Renaissance</div>
          <div>Colin Liu</div>
        </div>
        <div class="analyst_list">
          <div>CICC</div>
          <div>Liping Zhao</div>
        </div>
        <div class="analyst_list">
          <div>Citi</div>
          <div>Brian Gong</div>
        </div>
        <div class="analyst_list">
          <div>Credit Suisse</div>
          <div>Kenneth Fong</div>
        </div>
        <div class="analyst_list">
          <div>Everbright Securities</div>
          <div>Tianzi Fu</div>
        </div>
        <div class="analyst_list">
          <div>GF Securities</div>
          <div>Linlin Yang</div>
        </div>
        <div class="analyst_list">
          <div>Guosen Securities</div>
          <div>Xueheng Wang</div>
        </div>
        <div class="analyst_list">
          <div>Jefferies</div>
          <div>Thomas Chong</div>
        </div>
        <div class="analyst_list">
          <div>JPM</div>
          <div>Daniel Chen</div>
        </div>
        <div class="analyst_list">
          <div>Morgan Stanley</div>
          <div>Yang Liu</div>
        </div>
        <div class="analyst_list">
          <div>UOBKayHian</div>
          <div>Julia Yao</div>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  name: 'investorAnalyst',
  props: {},
  data() {
    return {}
  }
}
</script>
